import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import { VStack, Section } from 'tio-ui/components/layout';
import PageHero from 'tio-ui/components/page-hero';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import TuitionAssistanceFormsMentoring from 'tio-employee/components/tuition-assistance/forms/mentoring';
import embedCalendly from 'tio-common/modifiers/embed-calendly';
import type SessionContextService from 'tio-employee/services/session-context';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';

interface CollegePlanningMentorsSignature {
  model: {
    employee: EmployeeModel;
    phoneScheduler?: boolean;
  };
  Element: HTMLElement;
}

export default class CollegePlanningMentorsComponent extends Component<CollegePlanningMentorsSignature> {
  @service declare sessionContext: SessionContextService;
  // @tracked showSchedulingCalendar = this.args.model.phoneScheduler || false;
  @tracked calendlyError = false;

  // Used to prefill data within the calendly widget
  get calendlyPrefillData() {
    return {
      firstName: this.sessionContext.user?.person.firstName,
      lastName: this.sessionContext.user?.person.lastName,
    };
  }

  get showSchedulingCalendar() {
    return this.args.model.phoneScheduler || false;
  }

  onCalendlyError = () => {
    this.calendlyError = true;
  };
  <template>
    {{pageTitle (t "college_planning_mentors.header")}}
    <VStack class="gap-8">
      <PageHero
        @title={{t "college_planning_mentors.header"}}
        @subtitle={{t "college_planning_mentors.description"}}
        @gradient="brand-soft"
        class="tio-elevation-card-raised"
      />
      {{#if this.showSchedulingCalendar}}
        <Section>
          <:header>
            {{t "college_planning_mentors.coaching"}}
          </:header>
          <:body>
            <div
              id="calendly-container"
              class="h-[756px]"
              {{embedCalendly
                "https://calendly.com/tiocoaches"
                this.calendlyPrefillData
                this.onCalendlyError
              }}
            />
          </:body>
        </Section>
      {{else}}
        <Section>
          <:header>
            {{t "college_planning_mentors.speak_with_a_coach"}}
          </:header>
          <:body>
            <div class="tio-col">
              <p>{{t "college_planning_mentors.question"}}</p>
              <p>{{t "college_planning_mentors.please_answer"}}</p>
            </div>
            <TuitionAssistanceFormsMentoring @employee={{@model.employee}} @isNonTa={{true}} />
          </:body>
        </Section>
      {{/if}}
    </VStack>
  </template>
}
